import type { DemoKey } from './keys';

export const en: Record<DemoKey, string> = {
  'app.eyebrow': 'Math · 3D Geometry',
  'panel.figure': 'Scene',
  'panel.dims': 'Dimensions',
  'panel.style': 'Appearance',
  'panel.lines': 'Special lines',
  'style.body': 'Body',
  'style.line': 'Line',
  'style.cut': 'Section',
  'style.labels': 'Vertex labels',
  'group.face': 'Face diagonals / generators',
  'group.space': 'Diagonals / axes / medians',
  'split.label': 'Section',
  'btn.animate': 'Animate',
  'btn.reset': 'Reset',
  'hint.line1': 'Drag to rotate · Scroll to zoom',
  'hint.line2': 'Click a line to select it',
  'fig.cuboid': 'Cuboid',
  'fig.cube': 'Cube',
  'fig.triPrism': 'Regular triangular prism',
  'fig.hexPrism': 'Regular hexagonal prism',
  'fig.tetrahedron': 'Regular tetrahedron',
  'fig.squarePyramid': 'Regular square pyramid',
  'fig.cylinder': 'Right circular cylinder',
  'fig.cone': 'Right circular cone',
  'fig.sphere': 'Sphere',
  'fig.frustumPyramid': 'Square pyramid frustum',
  'fig.frustumCone': 'Cone frustum',
  'dim.length': 'length',
  'dim.width': 'width',
  'dim.height': 'height',
  'dim.side': 'side',
  'dim.radius': 'radius',
  'dim.r1': 'lower radius',
  'dim.r2': 'upper radius',
  'dim.sideBase': 'base side',
  'dim.sideTop': 'top side',
  'info.face': 'face',
  'info.center': 'through center',
  'info.diagonal': 'diagonal',
  'info.axial': 'axial diagonal',
  'info.diameter': 'diameter',
  'info.generator': 'generator',
  'info.axis': 'axis',
  'info.height': 'height',
  'info.median': 'median',
  'info.apothem': 'apothem',
  'info.diameterBase': 'base diameter',
  'info.diameterTop': 'top diameter',
};
